/**
 * Detects GET `/project/{id}/routine` (list routines for a project).
 * Does not match `/project/{id}/routine/{routineId}` or deeper paths.
 *
 * Used when the API may return 500 for an empty routine list (SCRUM-380); callers
 * treat that as `[]` and skip global error toasts for this request.
 */
export function requestPathname(url: string): string {
  try {
    return new URL(url).pathname;
  } catch {
    try {
      return new URL(url, 'http://localhost').pathname;
    } catch {
      const q = url.indexOf('?');
      return q >= 0 ? url.slice(0, q) : url;
    }
  }
}

export function isProjectRoutineListGet(url: string, method: string): boolean {
  if (method !== 'GET' && method !== 'get') {
    return false;
  }
  const path = requestPathname(url);
  return /\/project\/\d+\/routine$/.test(path);
}

/**
 * Detects POST `/project/{id}/routine/{routineId}/trigger`.
 *
 * Used to suppress the global interceptor error toast for routine trigger failures
 * (SCRUM-460) so that components can surface the actual server error message
 * without users seeing duplicate toasts.
 */
export function isRoutineTriggerPost(url: string, method: string): boolean {
  if (method !== 'POST' && method !== 'post') {
    return false;
  }
  const path = requestPathname(url);
  return /\/project\/\d+\/routine\/\d+\/trigger$/.test(path);
}
